<template>
  <div class="tw-shadow">
    <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0" v-if="ready">
      <b-tabs card fill>
        <b-tab v-for="(tab, key) in data" :title="key" :key="key" :active="key === defaultSelected">

          <h6 class="tw-font-bolder tw-mb-0">Subjects Retention</h6>
          <p class="text-secondary tw-text-xs">{{ tab.chartdata.datasets[0].data[0] + tab.chartdata.datasets[0].data[1] }} Subjects Screened and Enrolled</p>
          <doughnut-chart class="k-test" :chartdata="tab.chartdata" :options="tab.options"></doughnut-chart>
          <div id="enrollment-label">
            <h1 class="tw-text-4xl tw-font-bolder text-center tw-mb-0">{{ percentRetained(tab.chartdata) }}%</h1>
            <h5 class="tw-font-bolder text-center">Retained</h5>
          </div>

          <div class="text-right">
            <b-button :to="{ name: 'metrics-subject-enrollment-details'}" variant="outline-secondary">More</b-button>
          </div>
        </b-tab>
      </b-tabs>
      <div class="tw-mt-auto tw-flex tw-justify-end">
        <info-popover>
          <template v-slot:title>Subject Retention</template>
          <h5>Enrolled</h5>
          <p>Subjects Enrolled and Screened.</p>
          <h5>LTFU</h5>
          <p>Subjects Lost To Follow Up.</p>
        </info-popover>
      </div>
    </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DoughnutChart from "@/components/charts/DoughnutChart.vue";

import * as _ from 'lodash';

export default {
  mixins: [],
  components: {
    DoughnutChart
  },
  props: {},
  data: function() {
    return {
      ready: false,
      chartdata: {
        datasets: [],
        labels: ["Enrolled", "LTFU"]
      },
      defaultSelected: "Cohort",
      options: {
        responsive: true,
        maintainAspectRatio: true,
        cutoutPercentage: 65,
        circumference: Math.PI,
        rotation: -Math.PI,
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 18
          }
        },
        title: {
          display: false,
          text: "Enrolled Subjects"
        },
        tooltips: {
          bodyFontSize: 14
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      },
      data: {}
    };
  },
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      const that = this;

      const params = {
        used_by: 'subjectEnrolledDonut',
      }

      // use the same API with enrollment chart
      HTTP.get("/uganda/metrics/cluster-enrollment-chart/", { params: params })
        .then((response) => {

        // chartData[0] = Beginning Subjects Enrolled; chartData[1]: lost to followup (LTFU)
        const chartData = {"Cohort": [
          response.data.number_beginning_subject,
          response.data.number_beginning_subject - response.data.number_current_subject
        ]}

        _.each(chartData, (val, key) => {
          that.data[key] = {
            id: key.replace(' ', '-'),
            chartdata: _.cloneDeep(that.chartdata),
            options: _.cloneDeep(that.options)
          };

          // Get the number of Current Subjects Enrolled
          val[0] -= val[1]

          that.data[key].chartdata.datasets.push(
            {
                data: val,
                backgroundColor: ["#37B1CA", "#EB513E"]
            }
          );
        });

        that.ready = true;

      }).catch((error) => {
          HandleErrors.HandleErrors(error);
      });
    },
    percentRetained: function(chartdata) {
      let val = _.round((chartdata.datasets[0].data[0] / (chartdata.datasets[0].data[0] + chartdata.datasets[0].data[1])) * 100, 2);
      return _.isNaN(val) ? 0 : val;
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {}
  }
};
</script>

<style>
#enrollment-label {
  position: absolute;
  top: 68%;
  left: 50%;
  transform: translate(-50%, -50%);
}
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 .5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: .35rem .5rem;
}
</style>